import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu10",
  "use": "icon-menu10-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 52 52\" id=\"icon-menu10\">\r\n<path fill=\"currentColor\" d=\"M26.042,0.083C11.729,0.083,0.124,11.687,0.124,26c0,14.314,11.604,25.917,25.918,25.917\r\n\tc14.314,0,25.917-11.604,25.917-25.917C51.959,11.687,40.356,0.083,26.042,0.083z M39.089,45.119l-13.306-9.849l-12.889,9.438\r\n\tl4.897-15.159L5.521,20.32h15.468l4.848-14.438l5,14.438h15.727l-12.737,9.538L39.089,45.119z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol